import { format, parseISO, isValid } from "date-fns";

// Data da notificação (dd/MM) a partir do created_at da API. Sem data, não
// mostra nada — antes aparecia "10/07" fixo em todas.
export function dataNotificacao(createdAt) {
  if (!createdAt) return "";
  const data = parseISO(createdAt);
  return isValid(data) ? format(data, "dd/MM") : "";
}
